import type { ToteEngagementMode } from '@mote/api'
import { ToteEngagementModeEnum } from '@mote/api'
import { Block, Text } from '@mote/ui'
import styled, { css, th } from '@xstyled/styled-components'

export interface ResponseStyledProps {
  transparent?: boolean
  mode: ToteEngagementMode
}

export const Response = styled(Block).attrs({ gap: 8 })<ResponseStyledProps>`
  padding: 8px 16px;
  border-radius: 6px;
  border-width: 2px;
  border-style: solid;
  box-sizing: border-box;

  ${props => {
    switch (props.mode) {
      case ToteEngagementModeEnum.AFFIRMATIVE:
        return css`
          border-color: ${th.color('green.l1')};
          background-color: ${th.color('green.l3')};
          color: ${th.color('black')};
        `
      case ToteEngagementModeEnum.ASSISTIVE:
        return css`
          border-color: ${th.color('red.l1')};
          background-color: ${th.color('red.l3')};
          color: ${th.color('black')};
        `
    }

    if (props.transparent)
      return css`
        border-color: ${th.color('disabled.l1')};
        background-color: ${th.color('disabled.l1')};
        color: ${th.color('disabled.l2')};
      `

    return css`
      border-color: ${th.color('white')};
      background-color: ${th.color('white')};
      color: ${th.color('disabled.l2')};
    `
  }};
`

export const Container = styled(Block)

export const ResponseText = styled(Text).attrs({
  tag: 'span',
  fontSize: 14,
  fontWeight: 400,
  color: 'grey.d3'
})({})
